import { HiMenu, HiOutlineBell, HiOutlineViewGrid } from "react-icons/hi";
import { Link, useNavigate } from "react-router-dom";
import { Tooltip as ReactTooltip } from "react-tooltip";

import Logo2 from "Assets/Images/a_logo.png";
import Logo from "Assets/ayozat_logo.svg";
import LogoStream from "Assets/AyozatStreamwhite.png";
import NavbarPageNav from "components/shared/NavbarPageNav";
import { RouteName } from "constant/routeNames";
import { useRef, useState } from "react";
import { BiMenuAltLeft } from "react-icons/bi";
import { useSelector } from "react-redux";
import NavIconLayout from "./ContentNavBar/NavIconLayout";
import ProfileIconSubMenu from "./ContentNavBar/ProfileIconSubMenu";
import NotificationContent from "./shared/NotificationContent";
import UserChatNavIcon from "./user-chat/UserChatNavIcon";
import ConnectTvNavIcon from "./ConnectTv/ConnectTvNavIcon/ConnectTvNavIcon";

function ContentNavbar({ handleClick, title, isActive }: any) {
  const loggedInUser = useSelector((state: any) => state?.user?.currentUser);
  const [openChatDrawer, setOpenChatDrawer] = useState<boolean>(false);
  const [isNewChat, setIsNewChat] = useState<boolean>(false);

  // user chat
  const showDrawer = () => {
    setOpenChatDrawer(true);
  };
  const closeDrawer = () => {
    setOpenChatDrawer(false);
  };
  // end of user chat

  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");

  const clickLogin = (e: any) => {
    navigate(RouteName.Login);
  };

  const validateKeyword = (keyword: any) => {
    return keyword.trim() !== "";
  };

  // Event handler for key press in the input field
  const handleKeyPress = (event: any) => {
    if (event.key === "Enter" && validateKeyword(keyword)) {
      if (keyword !== "") {
        navigate(RouteName.Search.replace(":keyword", keyword));
      }
    }
  };

  const searchInputRef = useRef<HTMLInputElement>(null);

  const [isSearchOpen, setIsSearchOpen] = useState(false);

  return (
    <>
      {/* navbar in videopage */}
      {/*
        NOTE: do NOT put backdrop-blur / filter / transform on this sticky
        container — it would become the containing block for fixed-position
        modals rendered by its children (ConnectTv, etc.) and break their
        full-screen centering. The glass effect lives on the background layer
        below instead, which has no descendants.
      */}
      <div className="navbar sticky top-0 z-50 min-h-[60px] border-white/10">
        {/* glass background layer (no descendants -> safe for fixed modals) */}
        <div className="pointer-events-none absolute inset-0 -z-10 bg-[#0c0c0f]/80 backdrop-blur-xl" />

        <div className="flex h-16 w-[98%] items-center justify-between pr-5">
          {/* side bar toggle */}

          <span
            className="top-5 ml-8 cursor-pointer text-3xl text-white/80 transition-colors hover:text-white"
            onClick={handleClick}
          >
            {isActive ? (
              <>
                <HiMenu
                  size={35}
                  className="bi bi-filter-left mx-auto mr-8 px-1"
                />
              </>
            ) : (
              <>
                <BiMenuAltLeft
                  size={35}
                  className="bi bi-filter-left mr-8 px-1"
                />
              </>
            )}
          </span>

          {/* logo */}

          <Link to={RouteName.Home}>
            {/* AYOZAT */}
            {title ? (
              <>
                <div className="navbar-image ml-3 flex items-center text-xl font-extrabold max-sm:hidden">
                  <img src={Logo} alt="logo" />
                  <span className="ml-2 text-xl font-normal text-white">
                    {title && title}
                  </span>
                </div>
              </>
            ) : (
              <>
                <div className="ml-3 flex h-[15px] w-[230px] items-center text-xl font-extrabold max-sm:hidden">
                  <img src={LogoStream} alt="logo" className="" />
                </div>
              </>
            )}
          </Link>

          <Link to={RouteName.Home}>
            <div className="flex items-center text-xl font-extrabold max-sm:w-7 sm:hidden">
              {/* AYOZAT */}
              <img src={Logo2} alt="logo" />
            </div>
          </Link>

          {/* search bar section */}

          <div className="navbar-search grow justify-center">
            <div className="sm:ml-[35%] md:block">
              <div className="white-text relative flex items-center">
                <span
                  className="lg-hidden absolute left-4 flex items-center pr-3 text-white/50 max-sm:ml-[35%]"
                  onClick={() => setIsSearchOpen(true)}
                >
                  <svg
                    xmlns="http://ww50w3.org/2000/svg"
                    className="w-5 fill-current"
                    viewBox="0 0 35.997 36.004"
                  >
                    <path
                      id="Icon_awesome-search"
                      data-name="search"
                      d="M35.508,31.127l-7.01-7.01a1.686,1.686,0,0,0-1.2-.492H26.156a14.618,14.618,0,1,0-2.531,2.531V27.3a1.686,1.686,0,0,0,.492,1.2l7.01,7.01a1.681,1.681,0,0,0,2.384,0l1.99-1.99a1.7,1.7,0,0,0,.007-2.391Zm-20.883-7.5a9,9,0,1,1,9-9A8.995,8.995,0,0,1,14.625,23.625Z"
                    ></path>
                  </svg>
                </span>
                <div
                  className={`text-md w-[100%] rounded-full py-1.5 pl-12 pr-4 outline-none ${
                    isSearchOpen ? "max-sm:block" : "max-sm:hidden"
                  }`}
                >
                  <input
                    ref={searchInputRef}
                    type="text"
                    name="leadingIcon"
                    id="leadingIcon"
                    placeholder="Search.."
                    value={keyword}
                    onChange={(e) => setKeyword(e.target.value)}
                    onKeyPress={handleKeyPress}
                    className="text-md w-[50%] rounded-full border border-white/10 bg-white/5 px-4 py-2 text-white outline-none transition-all duration-200 placeholder:text-white/40 focus:border-white/25 focus:bg-white/10 max-sm:fixed max-sm:left-3 max-sm:right-3 max-sm:top-[64px] max-sm:z-50 max-sm:w-auto max-sm:bg-[#1a1a1d] max-sm:shadow-2xl max-sm:focus:bg-[#1a1a1d]"
                    onBlur={() => setIsSearchOpen(false)}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* right part of navbar */}
          <div className="flex items-center justify-end">
            <div id="google_translate_element" className="!mt-5"></div>

            {loggedInUser === null ? (
              <div className="navbar-end flex flex-none flex-row items-center">
                <NavIconLayout
                  icon={<HiOutlineViewGrid />}
                  content={<NavbarPageNav />}
                  className="max-md:hidden"
                />
                <button
                  className="white-text button-red ml-4 rounded-full px-8 py-2 transition-opacity hover:opacity-90"
                  onClick={clickLogin}
                >
                  Login
                </button>
              </div>
            ) : (
              <div className="navbar-end flex flex-none flex-row">
                <ConnectTvNavIcon />
                <UserChatNavIcon />
                <NavIconLayout
                  icon={<HiOutlineViewGrid />}
                  content={<NavbarPageNav />}
                  className="max-md:hidden"
                />
                {/* <NavIconLayout
                  icon={<HiOutlineBell />}
                  content={<NotificationContent />}
                /> */}
                <NavIconLayout
                  img={loggedInUser?.artwork_url}
                  isSubcribed={loggedInUser?.is_subscribed}
                  content={<ProfileIconSubMenu />}
                />
              </div>
            )}
          </div>
        </div>
      </div>
      <ReactTooltip
        id={`chat icon`}
        place="bottom"
        content={`Chat`}
        className="z-50"
      />
    </>
  );
}

export default ContentNavbar;